/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { centerTransactionControllerCreate } from '../fn/center-transaction/center-transaction-controller-create';
import { CenterTransactionControllerCreate$Params } from '../fn/center-transaction/center-transaction-controller-create';
import { centerTransactionControllerDelete } from '../fn/center-transaction/center-transaction-controller-delete';
import { CenterTransactionControllerDelete$Params } from '../fn/center-transaction/center-transaction-controller-delete';
import { centerTransactionControllerDeleteRepeat } from '../fn/center-transaction/center-transaction-controller-delete-repeat';
import { CenterTransactionControllerDeleteRepeat$Params } from '../fn/center-transaction/center-transaction-controller-delete-repeat';
import { centerTransactionControllerFind } from '../fn/center-transaction/center-transaction-controller-find';
import { CenterTransactionControllerFind$Params } from '../fn/center-transaction/center-transaction-controller-find';
import { centerTransactionControllerSearch } from '../fn/center-transaction/center-transaction-controller-search';
import { CenterTransactionControllerSearch$Params } from '../fn/center-transaction/center-transaction-controller-search';
import { centerTransactionControllerUpdate } from '../fn/center-transaction/center-transaction-controller-update';
import { CenterTransactionControllerUpdate$Params } from '../fn/center-transaction/center-transaction-controller-update';
import { CenterTransactionDto } from '../models/center-transaction-dto';
import { SearchCenterTransactionResponseDto } from '../models/search-center-transaction-response-dto';

@Injectable({ providedIn: 'root' })
export class CenterTransactionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `centerTransactionControllerSearch()` */
  static readonly CenterTransactionControllerSearchPath = '/api/center-transaction';

  /**
   * 매출/매입 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerTransactionControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerTransactionControllerSearch$Response(params: CenterTransactionControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchCenterTransactionResponseDto>> {
    return centerTransactionControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 매출/매입 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerTransactionControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerTransactionControllerSearch(params: CenterTransactionControllerSearch$Params, context?: HttpContext): Observable<SearchCenterTransactionResponseDto> {
    return this.centerTransactionControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<SearchCenterTransactionResponseDto>): SearchCenterTransactionResponseDto => r.body)
    );
  }

  /** Path part for operation `centerTransactionControllerCreate()` */
  static readonly CenterTransactionControllerCreatePath = '/api/center-transaction';

  /**
   * 매출/매입 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerTransactionControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerTransactionControllerCreate$Response(params: CenterTransactionControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterTransactionDto>> {
    return centerTransactionControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 매출/매입 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerTransactionControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerTransactionControllerCreate(params: CenterTransactionControllerCreate$Params, context?: HttpContext): Observable<CenterTransactionDto> {
    return this.centerTransactionControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterTransactionDto>): CenterTransactionDto => r.body)
    );
  }

  /** Path part for operation `centerTransactionControllerDelete()` */
  static readonly CenterTransactionControllerDeletePath = '/api/center-transaction';

  /**
   * 매출/매입 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerTransactionControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerTransactionControllerDelete$Response(params: CenterTransactionControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return centerTransactionControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 매출/매입 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerTransactionControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerTransactionControllerDelete(params: CenterTransactionControllerDelete$Params, context?: HttpContext): Observable<boolean> {
    return this.centerTransactionControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `centerTransactionControllerFind()` */
  static readonly CenterTransactionControllerFindPath = '/api/center-transaction/{id}';

  /**
   * 매출/매입 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerTransactionControllerFind()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerTransactionControllerFind$Response(params: CenterTransactionControllerFind$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterTransactionDto>> {
    return centerTransactionControllerFind(this.http, this.rootUrl, params, context);
  }

  /**
   * 매출/매입 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerTransactionControllerFind$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerTransactionControllerFind(params: CenterTransactionControllerFind$Params, context?: HttpContext): Observable<CenterTransactionDto> {
    return this.centerTransactionControllerFind$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterTransactionDto>): CenterTransactionDto => r.body)
    );
  }

  /** Path part for operation `centerTransactionControllerUpdate()` */
  static readonly CenterTransactionControllerUpdatePath = '/api/center-transaction/{id}';

  /**
   * 매출/매입 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerTransactionControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerTransactionControllerUpdate$Response(params: CenterTransactionControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterTransactionDto>> {
    return centerTransactionControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 매출/매입 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerTransactionControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerTransactionControllerUpdate(params: CenterTransactionControllerUpdate$Params, context?: HttpContext): Observable<CenterTransactionDto> {
    return this.centerTransactionControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterTransactionDto>): CenterTransactionDto => r.body)
    );
  }

  /** Path part for operation `centerTransactionControllerDeleteRepeat()` */
  static readonly CenterTransactionControllerDeleteRepeatPath = '/api/center-transaction/repeat';

  /**
   * 반복 매출/매입 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerTransactionControllerDeleteRepeat()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerTransactionControllerDeleteRepeat$Response(params: CenterTransactionControllerDeleteRepeat$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return centerTransactionControllerDeleteRepeat(this.http, this.rootUrl, params, context);
  }

  /**
   * 반복 매출/매입 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerTransactionControllerDeleteRepeat$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerTransactionControllerDeleteRepeat(params: CenterTransactionControllerDeleteRepeat$Params, context?: HttpContext): Observable<boolean> {
    return this.centerTransactionControllerDeleteRepeat$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
